import './pointslistitem.css'

export const PointsListItem = {
    props: {
        number: {
            type: Number,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
        draggable: {
            type: Boolean,
            required: false,
            default: false,
        },
        removable: {
            type: Boolean,
            required: false,
            default: false,
        },
        onClick: {
            type: Function,
            required: false,
            default: function () {
                console.log('click event')
            },
        },
        onDragStart: {
            type: Function,
            required: false,
            default: function () {
                console.log('drag event started');
            },
        },
        onDragEnd: {
            type: Function,
            required: false,
            default: function () {
                console.log('drag event ended');
            },
        },
        onDragOver: {
            type: Function,
            required: false,
            default: function () {
                console.log('dragover event');
            },
        },
        onDelete: {
            type: Function,
            required: false,
            default: function () {
                console.log('delete event');
            },
        },
        // onSelect: {
        //   type: Function,
        //   required: false,
        //   default: function () {
        //       console.log('select event');
        //   },
        // },
        // canSelect: {
        //     type: Boolean,
        //     required: false,
        //     default: false,
        // },
        pointIndexIcon: {
            type: Number,
            required: false,
            default: null,
        },
        additionalClasses: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            isDragging: false, // Управляем состоянием перетаскивания
        };
    },
    methods: {
        enableDrag() {
            this.isDragging = true; // Включаем перетаскивание при нажатии на иконку
        },
        disableDrag() {
            this.isDragging = false; // Отключаем перетаскивание после отпускания
        },
        HandleClick() {
            this.onClick();
        },
        HandleDragStart(event) {
            // this.isDragging = true;
            event.target.classList.add('dragging');
            this.onDragStart(event);
        },
        HandleDragOver(event) {
            this.onDragOver(event);
        },
        HandleDragEnd(event) {
            this.isDragging = false; // Отключаем перетаскивание после завершения
            this.onDragEnd(event);
        },
    },
    // language=Vue
    template: `
      <div
          class="points-list-item"
          :class="[{ 'dragging': isDragging }, additionalClasses]"
          :draggable="draggable"
          @dragstart="HandleDragStart"
          @dragover.prevent="HandleDragOver"
          @drop="HandleDragEnd"
          @click="HandleClick"
      >
        <div v-if="pointIndexIcon !== null" class="route-waypoint-icon-view"
             :class="'_index_'+pointIndexIcon" :data-icon="pointIndexIcon"></div>
        <!--        <div class="points-list-item__number">{{ number }}</div>-->
        <div class="points-list-item__text">{{ text }}</div>
        <!-- Иконка для отбора -->
<!--        <input v-if="canSelect" type="checkbox"-->
<!--            class="checkbox-input"-->
<!--            @change="onSelect"-->
<!--        >-->
        
        <div
            v-if="removable"
            class="points-list-item__icon__container"
            @click="onDelete"
        >
            ❌
        </div>
      </div>
    `
};

//   <img class="points-list-item__icon__img" src="/local/js/muit/ymap-routing-vue/public/deleteicon.svg">
